type Viewable = { zoomBy(factor: number): void; resetView(): void };

export default function ViewControls({ handleRef, inline = false }: { handleRef: React.MutableRefObject<Viewable | null>; inline?: boolean }) {
  return (
    <div className={inline ? 'view-controls is-inline' : 'view-controls'} role="group" aria-label="Move around the scene">
      <button type="button" className="view-btn" aria-label="Zoom in" onClick={() => handleRef.current?.zoomBy(0.75)}>+</button>
      <button type="button" className="view-btn" aria-label="Zoom out" onClick={() => handleRef.current?.zoomBy(1.33)}>−</button>
      <button type="button" className="view-btn view-reset" aria-label="Reset view" onClick={() => handleRef.current?.resetView()}>
        <span aria-hidden="true">⟲</span>
        <span className="view-reset-text">Reset view</span>
      </button>
    </div>
  );
}
